import { isVendaNaoGerada, getComissionadoNormalized, notification } from '@/plugins/helpers'
import { AlertTypes } from '../plugins/alerts_types'
const mensagensAnaliseCredito = {
  REPROVADO: 'Sentimos muito, mas nesse momento a venda foi cancelada por não atender aos requisitos mínimos exigidos pelas atuais políticas da administradora. Para maiores detalhes, procure a equipe comercial.',
  ANALISAR: 'Prezado Parceiro, no momento, o CPF/CNPJ indicado está aguardando validação de dados. Este processo pode demorar, por favor, consulte mais tarde!',
  ANALISAR_GRANDE_NEGOCIO: 'Prezado parceiro, no momento a operação solicitada se enquadra em um grande negócio, um protocolo será aberto no Credita, por favor, acesse-o indicando o CPF/CNPJ do cliente para seguir com a proposta.',
  PENDENTE: 'Proposta em validação biométrica pela análise cadastral.',
  PENDENCIA_CADASTRAL: 'Caro parceiro sua proposta foi definida como "Pendente" pelo motor de crédito, indicando que alguns dados cadastrais não foram inclusos corretamente. Por favor, revise-os ou defenda-os a partir dos botões. Qualquer duvida, entre em contato com a Área de Suporte.'
}
export default {
  data: () => ({
    status_analise_cadastral: {
      status_aprovado: 'Aprovado',
      status_rejeitado: 'Reprovado',
      status_analisar: 'Analisar',
      status_pendente: 'Pendente',
      status_pendencia_cadastral: 'Pendência Cadastral'
    },
    is_venda_analise: false,
    is_venda_reprovada: false,
    is_venda_aprovada: false,
    is_venda_pendente: false,
    is_venda_pendencia_cadastral: false,
    remove_delete_sale_button: false
  }),
  methods: {
    async checkAnaliseCadastral (id_pedido, grupo_pontual = false, grupo_praja = false, item_painel = false) {
      const id_usuario = this.$session.get('id_usuario_interno')
      let is_needed_to_block_sale = null
      let is_needed_to_check_sale = null
      let loading = null
      let tentativas_analise_cadastral = 0
      if (item_painel === false) {
        try {
          const [block_sale, check_sale, credit_analisys_tries] = await this.$http.post(`/check/analise_cadastral/configuracoes`, { id_usuario, grupo_pontual, grupo_praja }).then((response) => [response.data.block, response.data.check, response.data.tentativas_analise_cadastral])
          is_needed_to_block_sale = block_sale && check_sale
          is_needed_to_check_sale = check_sale
          tentativas_analise_cadastral = credit_analisys_tries
        } catch (e) {
          notification(AlertTypes.WARN, 'Houve uma instabilidade, sugerimos tentar novamente. Caso o erro persistir, entre em contato com a Área de Suporte.')
          return
        }
      }
      const comissionado = this.getComissionadoData(this.$session.get('id_comissionado_venda'), item_painel)
      const dados_comissionado_ponto_venda = {
        cd_ponto_venda: typeof item_painel.cod_ponto_venda !== 'undefined' ? item_painel.cod_ponto_venda : this.$session.get('cd_ponto_venda'),
        nm_ponto_venda: typeof item_painel.nome_ponto_venda !== 'undefined' ? item_painel.nome_ponto_venda : this.$session.get('nm_ponto_venda'),
        cd_comissionado: comissionado.cd_comissionado,
        nm_comissionado: comissionado.nm_comissionado
      }
      try {
        if (is_needed_to_check_sale) {
          this.$store.commit('setAdditionalLoadingText', 'Estamos validando os dados. Este processo pode demorar alguns instantes. Por favor, aguarde!')
          const totalTime = 5000 + 4000 * tentativas_analise_cadastral
          loading = { totalTime, totalRequests: tentativas_analise_cadastral }
        }
        const status = await this.$http.post('/check/analise_cadastral',
          { id_pedido, grupo_pontual, grupo_praja, dados_comissionado_ponto_venda, id_usuario, consultar_via_painel: !!item_painel },
          { options: { showAdditionalLoadingText: is_needed_to_check_sale, loading } }).then(r => {
          return r.data.status
        }).catch((error) => {
          throw error
        })

        const pedidoAtualizado = await this.$http.get(`/vendas/${id_pedido}`)
        const novoStatus = pedidoAtualizado.data.status_pedido
        const novaAnalise = pedidoAtualizado.data.analiseCredito

        if (novoStatus) {
          this.pedido.status_pedido = novoStatus
        }

        if (novaAnalise) {
          this.pedido.analiseCredito = novaAnalise
        }

        if (item_painel !== false) {
          notification(AlertTypes.INFO, 'Consulta de análise de crédito refeita com sucesso! A listagem será atualizada!')
          return
        }

        if (!is_needed_to_block_sale) {
          return true
        }
        switch (status) {
          case this.status_analise_cadastral.status_aprovado:
            this.removeDeleteSaleButton()
            notification(AlertTypes.SUCCESS, 'Proposta de crédito aprovada!!', '', false, false, false)
            return true
          case this.status_analise_cadastral.status_analisar:
            this.removeDeleteSaleButton()
            this.setVendaAnalise()
            if (this.pedido.grande_negocio) {
              console.log('é grande negocio? ', this.pedido.grande_negocio)

              notification(AlertTypes.WARN, mensagensAnaliseCredito.ANALISAR_GRANDE_NEGOCIO)
            } else {
              notification(AlertTypes.WARN, mensagensAnaliseCredito.ANALISAR)
            }
            return false
          case this.status_analise_cadastral.status_rejeitado:
            this.removeDeleteSaleButton()
            this.setVendaReprovada()
            notification(AlertTypes.ERROR, mensagensAnaliseCredito.REPROVADO)
            return false
          case this.status_analise_cadastral.status_pendente:
            this.removeDeleteSaleButton()
            this.setVendaPendente()
            notification(AlertTypes.WARN, mensagensAnaliseCredito.PENDENTE)
            return false
          case this.status_analise_cadastral.status_pendencia_cadastral:
            this.removeDeleteSaleButton()
            this.setVendaPendenciaCadastral()
            notification(AlertTypes.INFO, mensagensAnaliseCredito.PENDENCIA_CADASTRAL)
            return false
          default:
            throw new Error('Valor inválido')
        }
      } catch (error) {
        await this.garanteErroNaAnaliseGravouAnalisar(id_pedido, is_needed_to_check_sale, dados_comissionado_ponto_venda, is_needed_to_block_sale, item_painel)
        if (!is_needed_to_block_sale && item_painel === false) {
          return true
        }
        return false
      }
    },
    async garanteErroNaAnaliseGravouAnalisar (id_pedido, is_needed_to_check_sale, dados_comissionado_ponto_venda, is_needed_to_block_sale, item_painel) {
      if (!is_needed_to_check_sale) {
        return true
      }
      await this.$http.post(`/pedido/garante_possui_status/${id_pedido}`, { dados_comissionado_ponto_venda }, { options: { showAdditionalLoadingText: is_needed_to_check_sale } }).then((response) => {
        if (response.data.ok && !(!is_needed_to_block_sale && item_painel === false)) {
          notification(AlertTypes.WARN, mensagensAnaliseCredito.ANALISAR)
        }
      }).catch((err) => { console.error(err) })
    },
    async decideSale (consulta, autorizacao, situacao_antiga, motivo = '') {
      this.$http.post('/painel/authorize-sale/credito-analise', {
        id_pedido: consulta.id_pedido,
        id_consulta: consulta.id_consulta,
        motivo: motivo,
        situacao_antiga,
        auth: autorizacao
      }).then(res => {
        notification(AlertTypes.INFO, `Venda ${autorizacao ? 'autorizada' : 'negada'} pela análise cadastral.`)
      })
        .catch(() => {
          this.motivo = ''
          this.$refs.form.resetValidation()
          notification('error', `Erro ao ${autorizacao ? 'autorizar' : 'negar'} venda pela análise cadastral.`)
        })
    },
    async pendenciarDadosAnalise ({ consulta, motivo, situacaoAntiga, pendencias }) {
      const payload = {
        id_pedido: consulta.id_pedido,
        id_consulta: consulta.id_consulta,
        motivo,
        situacao_antiga: situacaoAntiga,
        ...pendencias
      }
      try {
        let response
        response = await this.$http.post('/painel/pendenciar-dados/credito-analise', payload)
        notification(AlertTypes.SUCCESS, response.data.message)
      } catch (error) {
        let errorMessage = error.response?.data?.error || error.message
        notification(AlertTypes.ERROR, errorMessage)
      }
    },
    getComissionadoData (id_comissionado, comissionado_painel) {
      if (comissionado_painel !== false) {
        return { cd_comissionado: comissionado_painel.cod_comissionado, nm_comissionado: comissionado_painel.nome_comissionado }
      }
      return getComissionadoNormalized(id_comissionado, this.$session.get('comissionados'), this.$session.get('vendas_backoffice'))
    },
    verificaSeDeveChecarAnaliseCadastral () {
      return this.pedido?.cliente?.id_cliente && this.pedido?.cliente?.id_cliente > 0 && ((this.pedido?.vl_parcela && this.pedido?.vl_parcela > 0) || (this.pedido?.plano?.id_plano_venda && this.pedido?.plano?.id_plano_venda > 0))
    },
    setVendaAnalise () {
      this.is_venda_analise = true
    },
    setVendaReprovada () {
      this.is_venda_reprovada = true
    },
    setVendaPendente () {
      this.is_venda_pendente = true
    },
    setVendaPendenciaCadastral () {
      this.is_venda_pendencia_cadastral = true
    },
    setVendaAprovada () {
      this.is_venda_aprovada = true
    },
    removeDeleteSaleButton () {
      this.remove_delete_sale_button = true
    },
    isVendaNaoGerada (status_pedido) {
      return isVendaNaoGerada(status_pedido)
    },
    validarRegraNotificacao (result) {
      if (result && result.data && result.data.notificacao && result.data.notificacao.id_consulta && result.data.notificacao.situacao) {
        if (result.data.notificacao.situacao === this.status_analise_cadastral.status_analisar && !result.data.notificacao.notificacao_analise) {
          return true
        }

        if (result.data.notificacao.situacao === this.status_analise_cadastral.status_rejeitado && !result.data.notificacao.notificacao_reprovado) {
          return true
        }

        if (result.data.notificacao.situacao === this.status_analise_cadastral.status_pendente && !result.data.notificacao.notificacao_pendente) {
          return true
        }

        if (result.data.notificacao.situacao === this.status_analise_cadastral.status_pendencia_cadastral && !result.data.notificacao.notificacao_pendencia_cadastral) {
          return true
        }
      }
      return false
    },
    async avisoPedido (id_pedido) {
      this.$http.get('/notificacao/pedido/' + id_pedido)
        .then(result => {
          if (this.validarRegraNotificacao(result)) {
            const analise = result.data.notificacao.situacao === this.status_analise_cadastral.status_analisar
            const pendente = result.data.notificacao.situacao === this.status_analise_cadastral.status_pendente
            const pendencia_cadastral = result.data.notificacao.situacao === this.status_analise_cadastral.status_pendencia_cadastral
            let mensagem = ''
            let alert_type = ''
            if (analise) {
              if (this.pedido.grande_negocio) {
                mensagem = mensagensAnaliseCredito.ANALISAR_GRANDE_NEGOCIO
                alert_type = AlertTypes.WARN
              } else {
                mensagem = mensagensAnaliseCredito.ANALISAR
                alert_type = AlertTypes.WARN
              }
            } else if (pendente) {
              mensagem = mensagensAnaliseCredito.PENDENTE
              alert_type = AlertTypes.WARN
            } else if (pendencia_cadastral) {
              mensagem = mensagensAnaliseCredito.PENDENCIA_CADASTRAL
              alert_type = AlertTypes.INFO
            } else {
              mensagem = mensagensAnaliseCredito.REPROVADO
              alert_type = AlertTypes.ERROR
            }
            notification(alert_type, mensagem, '', false, false, false)
            this.notificarLeituraAviso(result.data.notificacao.id_consulta, analise, pendente, pendencia_cadastral)
          }
        })
    },
    async verificarCamposParaAnaliseCadastral () {
      try {
        const res = await this.$http.get(`/check/analise_cadastral/${this.pedido.id_pedido}`)

        if (res.data.success) {
          return true
        }

        notification(AlertTypes.ERROR, res.data.message)
        return false
      } catch (error) {
        notification(AlertTypes.ERROR, error.response.data.message)
        return false
      }
    },
    async notificarLeituraAviso (id_consulta, analise, pendente, pendencia_cadastral, notificarLeituraAviso) {
      const options = { silent: true }
      const params = { id_consulta, analise, pendente, pendencia_cadastral, notificarLeituraAviso, leitura: true }
      this.$http.put('/notificacao/pedido', { ...params }, { options })
    }
  }
}
